import { render, staticRenderFns } from "./PurchaseOfferingPayment.vue?vue&type=template&id=fd66daf4&scoped=true"
import script from "./PurchaseOfferingPayment.vue?vue&type=script&lang=js"
export * from "./PurchaseOfferingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd66daf4",
  null
  
)

export default component.exports